module.exports = __webpack_public_path__ + "8e0b00a073e7a5f289147894f3245e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/topbar/logo_small.png
// module id = 324
// module chunks = 0